const COMPONENT_NAME = "WarehouseList";
const SEARCH_FIELD_MAX_LENGTH = 50;
const BATCH_SIZE_MAX = 3;
const IS_SHOWROOM_LOCATION = "hs";
const ALTERNATE_BODY_TEXT_KEY = "altbody";
const TITLE_TEXT_KEY = "title";
const FMW = "FMW";
const CMW = "CMW";
const VIEW_MORE_LOCATIONS_TEXT_KEY = "viewmorelocations";
const DISTANCE_UNIT = {
  "en-us": "mi",
  "en-ca": "km",
  "fr-ca": "km"
};
const STORE_IDS = {
  USBC: "10301",
  USBD: "11301",
  CABC: "10302",
  CABD: "11303"
};
const COUNTRY_CODE = {
  USBC: "US",
  USBD: "US",
  CABC: "CA",
  CABD: "CA"
};
export {
  ALTERNATE_BODY_TEXT_KEY,
  BATCH_SIZE_MAX,
  CMW,
  COMPONENT_NAME,
  COUNTRY_CODE,
  DISTANCE_UNIT,
  FMW,
  IS_SHOWROOM_LOCATION,
  SEARCH_FIELD_MAX_LENGTH,
  STORE_IDS,
  TITLE_TEXT_KEY,
  VIEW_MORE_LOCATIONS_TEXT_KEY
};
